<template>
	<div style="min-width: 1372px;overflow-x: hidden;">
		<pcHeader />
		<div>
			<router-view />
		</div>
		<pcFooter />
	</div>
</template>

<script>
import pcHeader from '@/components/pc/pcHeader'
import pcFooter from '@/components/pc/pcFooter'
export default {
	components: {
		pcHeader,
		pcFooter
	}
}
</script>

<style></style>
